module.exports = __webpack_public_path__ + "img/discuss-screen-dark-en.6c86c43f.webp";